module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-fr.9205b163da1abddfe198.svg";